import styled from "styled-components";
import { mq } from "../../styles/canonical/breakpoints";

/* Versão inline (2026-05-31): os chevrons ficam coladinhos no título da
   página, um de cada lado (‹ Título ›) — não numa barra separada. A
   usuária deixou claro (com desenho) que é assim que tem que ser. O
   componente envolve o próprio <h1> da página, preservando o estilo dele. */

/* Header do mockup (2026-07): [‹][›] em caixas, juntos, antes do bloco
   eyebrow + título. */
export const Linha = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 13px;
  min-width: 0;

  /* Celular/tablet (redesenho mobile 2026-09-24): tudo numa linha só —
     [‹][›] Título…  3/15. O eyebrow "PCP / Etapa 3 de 15" some e vira o
     contador compacto à direita. */
  @media ${mq.tablet} {
    display: flex;
    width: 100%;
    gap: 8px;
  }
`;

export const ChevronGroup = styled.div`
  display: flex;
  gap: 5px;
  flex-shrink: 0;
`;

export const TituloBloco = styled.div`
  min-width: 0;

  @media ${mq.tablet} {
    flex: 1 1 auto;

    h1 {
      font-size: 17px;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  /* Título no peso/proporção do mockup (600, não 700; line-height e tracking
     apertados; margin 0 — o PageTitle global traz ~19px de margem vertical
     que inflava o bloco, abria um vão fantasma entre eyebrow e título e
     empurrava os chevrons pra baixo). Escopado ao fluxo — off-fluxo o
     NavegacaoEtapa renderiza só o título, sem este wrapper. Mantém a fonte
     do ERP (var(--font-display)). */
  h1 {
    margin: 0;
    font-weight: 600;
    font-size: 29px;
    line-height: 1.05;
    letter-spacing: -0.02em;
  }
`;

export const Eyebrow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  /* Mockup: eyebrow na fonte do corpo (não mono), só uppercase+tracking. */
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textTertiary};
  margin-bottom: 3px;

  .sep {
    opacity: 0.5;
  }

  @media ${mq.tablet} {
    display: none;
  }
`;

/* Contador "3/15" — só no celular/tablet, no lugar do eyebrow. */
export const Contador = styled.span`
  display: none;

  @media ${mq.tablet} {
    display: inline-block;
    flex: 0 0 auto;
    font-size: var(--text-min, 12px);
    font-weight: 600;
    letter-spacing: 0.04em;
    color: ${({ theme }) => theme.textTertiary};
    font-variant-numeric: tabular-nums;
  }
`;

export const Chevron = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 9px;

  @media ${mq.tablet} {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  transition: background 0.16s ease, color 0.16s ease, border-color 0.16s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;
